import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { SearchBar } from "@/components/SearchBar";
import { Fleet } from "@/components/Fleet";
import { PhotoStrip } from "@/components/PhotoStrip";
import { DeliveryBanner } from "@/components/DeliveryBanner";
import { Offers } from "@/components/Offers";
import { Footer } from "@/components/Footer";
import { MobileNav } from "@/components/MobileNav";
import { BookingFlow } from "@/components/BookingFlow";
import { ChatWidget } from "@/components/ChatWidget";
import { useLenis } from "@/App";
import { FLEET_FALLBACK, LOCATIONS_FALLBACK } from "@/constants/site";
import { toast } from "sonner";
import axios from "axios";
import { useCallback, useEffect, useMemo, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const defaultPickup = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(9, 0, 0, 0);
  return d;
};
const defaultDropoff = () => {
  const d = new Date();
  d.setDate(d.getDate() + 4);
  d.setHours(10, 0, 0, 0);
  return d;
};

export default function Home() {
  const lenis = useLenis();
  const [search, setSearch] = useState({ location: LOCATIONS_FALLBACK[0], pickup: defaultPickup(), dropoff: defaultDropoff() });
  const [categories, setCategories] = useState(FLEET_FALLBACK);
  const [fleetOffline, setFleetOffline] = useState(false);
  const [fleetMsg, setFleetMsg] = useState("");
  const [booking, setBooking] = useState({ open: false, category: null, model: null });

  const days = useMemo(
    () => Math.max(1, Math.ceil((search.dropoff.getTime() - search.pickup.getTime()) / 86400000)),
    [search]
  );

  useEffect(() => {
    axios
      .get(`${API}/fleet`)
      .then(({ data }) => {
        setCategories(data.categories);
        // COMANDO SITO 1.3: gestionale non raggiungibile → avviso "Disponibilità in aggiornamento"
        setFleetOffline(!!(data.fleet_offline || data.gestionale_offline));
        setFleetMsg(data.offline_message || data.message || "");
      })
      .catch(() => {});
  }, []);

  const scrollTo = useCallback(
    (id) => {
      if (id === "top") {
        if (lenis) lenis.scrollTo(0);
        else window.scrollTo({ top: 0, behavior: "smooth" });
        return;
      }
      if (lenis) lenis.scrollTo(`#${id}`, { offset: -56 });
      else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    },
    [lenis]
  );

  const handleSearch = () => {
    if (search.dropoff <= search.pickup) {
      toast.error("La consegna deve essere dopo il ritiro");
      return;
    }
    scrollTo("flotta");
    toast.success(`Ricerca pronta: ${search.location.name} • ${days} giorni`, {
      description: "Prezzi da gestionale — nessuna carta di credito richiesta.",
    });
  };

  return (
    <div className="min-h-screen bg-white">
      <Header onNav={scrollTo} />
      <main className="pt-14 pb-20 md:pb-0">
        <Hero chip={{ days, locationName: search.location.name }} />
        <SearchBar
          search={search}
          days={days}
          locations={LOCATIONS_FALLBACK}
          onChange={(patch) => setSearch((s) => ({ ...s, ...patch }))}
          onSearch={handleSearch}
        />
        {fleetOffline && (
          <div className="max-w-6xl mx-auto px-4 -mt-2" data-testid="fleet-offline-banner">
            <p className="rounded-xl bg-amber-50 border border-amber-200 p-3 text-xs text-amber-900">
              <b>{fleetMsg || "Disponibilità in aggiornamento, contattaci"}</b> — tel. <a href="tel:3509656394" className="font-bold underline">350 9656394</a>
            </p>
          </div>
        )}
        <Fleet
          categories={categories}
          days={days}
          onChoose={(category, model) => setBooking({ open: true, category, model })}
        />
        <PhotoStrip />
        <DeliveryBanner
          onVerify={() => {
            scrollTo("contatti");
            toast.info("Consegna gratuita da 5 a 90 minuti, in base alla distanza", {
              description: "Aeroporto, stazioni, hotel, B&B, casa. Chiamaci: 350 965 6394",
            });
          }}
        />
        <Offers />
        <Footer />
      </main>
      <MobileNav onNav={scrollTo} onBook={() => setBooking({ open: true, category: "CITY", model: null })} />
      <BookingFlow
        open={booking.open}
        category={booking.category}
        model={booking.model}
        search={search}
        days={days}
        onClose={() => setBooking({ open: false, category: null, model: null })}
      />
      <ChatWidget />
    </div>
  );
}
